export const ADMIN_IDLE_TIMEOUT_MS = 5 * 60 * 1000;

const TAB_SESSION_KEY = "adminTabSession";
const LAST_ACTIVITY_KEY = "adminLastActivity";
export const ADMIN_SESSION_EXPIRED_KEY = "adminSessionExpired";

export const isAdminUser = () => localStorage.getItem("role") === "ADMIN";

export const startAdminSession = () => {
  sessionStorage.setItem(TAB_SESSION_KEY, "1");
  markAdminActivity();
};

export const clearAdminSession = () => {
  sessionStorage.removeItem(TAB_SESSION_KEY);
  sessionStorage.removeItem(LAST_ACTIVITY_KEY);
};

export const hasAdminTabSession = () => sessionStorage.getItem(TAB_SESSION_KEY) === "1";

export const markAdminActivity = () => {
  sessionStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
};

export const isAdminSessionExpired = () => {
  if (!isAdminUser() || !localStorage.getItem("jwt")) {
    return false;
  }
  if (!hasAdminTabSession()) {
    return true;
  }
  const lastActivity = Number(sessionStorage.getItem(LAST_ACTIVITY_KEY) || 0);
  if (!lastActivity) {
    return true;
  }
  return Date.now() - lastActivity >= ADMIN_IDLE_TIMEOUT_MS;
};
